<template>
	<main class="app-main">
		<div class="content-wrap">
			<section class="content-section">
				<header class="section-header">
					<h2 class="section-title">{{ $t('routes.debts.title') }}</h2>
				</header>
				<article>
					<actions-panel>
						<button class="button style-3" @click.stop.prevnet="$store.commit('SHOW_DEBT_CREATE_FORM')">
							<span class="inner">{{ $t('debts.add_debt') }}</span>
						</button>
						<router-link :to="$t('routes.home.path')" class="button style-1">
							<span class="inner">{{ $t('general.back') }}</span>
						</router-link>
					</actions-panel>
					<chart-finance-panels-group :charts-data="chartsData"
					                            :finance-panels-data="financePanelsData"
					                            :title="$t('debts.debts_list')"
					                            v-if="financePanelsData.length"/>
					<p v-else>{{ $t('debts.no_debts') }}</p>
				</article>
			</section>
		</div>
	</main>
</template>

<script>


import ActionsPanel from "@/components/panels/ActionsPanel";
import ChartFinancePanelsGroup from "@/components/containers/ChartFinancePanelsGroup";
import investmentsMixin from "@/mixins/investmentsMixin";

export default {
	name: "Debts",
	mixins: [investmentsMixin],
	components: {
		ActionsPanel,
		ChartFinancePanelsGroup
	},
	computed: {
		financePanelsData(){
			let data = [];
			this.$store.state.views.debts.forEach((item) => {
				data.push({
					id: item.id,
					icon: item.icon,
					name: item.name,
					value: item.amount || 0,
					type: item.type,
					finance_type: 'debt'
				});
			});

			return data;
		},
		chartsData() {
			let data = [
				this.getPortfoliosChartOptions(),
			];

			let categories = {};

			this.$store.state.views.debts.forEach((item) => {
				let value = parseFloat(item.amount);
				if(!categories[item.category]) {
					categories[item.category] = 0;
				}

				categories[item.category] += value;
			});

			let labels = [];
			let series = [];

			Object.entries(categories).forEach(([key, value]) => {
				if(value > 0){
					labels.push(key);
					series.push(value);
				}
			});

			data[0].chartOptions.labels = labels;
			data[0].series = series;

			return data;
		},
	},
	methods: {

	}
}
</script>

<style scoped lang="scss">

</style>